
import { BrowserRouter as Router, useParams, useLocation } from "react-router-dom";

import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardMedia } from '@material-ui/core';
import useImageFetch from "../hooks/useImageFetch";

const useStyles = makeStyles({
  root: {
    maxWidth: 480,
  },
  media: {
    height: 640,
  },
});


export default function Images() {

  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const lassInvoiceNo = query.get("lassInvoiceNo");
  console.log(` imageInvoieNum => ${lassInvoiceNo}`)

  const classes = useStyles();  
  const imageLinks = useImageFetch(lassInvoiceNo);  

  return (
    <div>
       <Card variant="outlined" color="primary">
          운송장 번호: {lassInvoiceNo}
       </Card>
      {!imageLinks || imageLinks.length == 0 ?  <Card> 이미지를 찾을수 없습니다 </Card> :( imageLinks.map((link, index) => (
        <Card key={index} className={classes.root}>
          <CardMedia
            className={classes.media}
            image={link}
            title={`Image ${index + 1}`}
          />
        </Card>)
      ))}
    </div>
  );
}

